import { useState } from 'react';
import { useNotify, useRecordContext } from 'react-admin';
import { getUrl } from '@/components/buttons/LinkButton/utils';
import { openDashboardForCandidate } from '@/components/utils/Actions/dashboardNavigation';
import { appendOpenDrugTestModalParam } from '../utils';
import { ORDER_A_LA_CARTE_LABEL } from './constants';
import { OrderPrimaryButton } from './styled';
import type { OrderALaCarteButtonProps } from './types';

/**
 * Partner-change → Dashboard redirect with `openDrugTestModal=1`.
 * Dashboard decides whether the modal actually opens.
 */
const OrderALaCarteButton = ({ label = ORDER_A_LA_CARTE_LABEL }: OrderALaCarteButtonProps) => {
  const record = useRecordContext();
  const notify = useNotify();
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    if (!record?.uuid || busy) return;
    setBusy(true);
    try {
      await openDashboardForCandidate(getUrl('dashboard', record.uuid), notify, {
        transformRedirectUrl: appendOpenDrugTestModalParam,
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <OrderPrimaryButton variant="contained" disableElevation onClick={handleClick} disabled={busy || !record?.uuid}>
      {label} ↗
    </OrderPrimaryButton>
  );
};

export default OrderALaCarteButton;
